import { render, staticRenderFns } from "./admin-detail.component.html?vue&type=template&id=6a822800&scoped=true&external"
import script from "./admin-detail.component.ts?vue&type=script&lang=ts&external"
export * from "./admin-detail.component.ts?vue&type=script&lang=ts&external"
import style0 from "./admin-detail.component.scss?vue&type=style&index=0&id=6a822800&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a822800",
  null
  
)

export default component.exports